import React from 'react'
import {Box} from '@mui/material'
import SelectNew from 'src/components-new/inputs/SelectNew'
import UnitValueField from './UnitValueField'
import {ModeOfAssumptionValue} from './secondaryTherapyFormUtils'
import {DEVICE_OF_ASSUMPTION_OPTIONS, MODE_OF_ASSUMPTION_OPTIONS, SPEED_UNIT_OPTIONS} from '../../patient/tabs/therapy/therapyOptions'
import {SecondaryTherapyDataSchemaElement} from 'src/constants/secondaryTherapyFields'

// New-style equivalent of src/components/templates/TherapyDialogs/ModeOfAssumptionFields.tsx

interface ModeOfAssumptionStepProps {
  value: ModeOfAssumptionValue
  onChange: (value: ModeOfAssumptionValue) => void
  dataSchema: SecondaryTherapyDataSchemaElement[]
}

export default function ModeOfAssumptionStep({value, onChange, dataSchema}: ModeOfAssumptionStepProps): JSX.Element {
  const set = (patch: Partial<ModeOfAssumptionValue>): void => onChange({...value, ...patch})
  const isFieldVisible = (key: string): boolean => dataSchema.some((element) => element.value === key)
  const fieldLabel = (key: string, fallback: string): string => dataSchema.find((element) => element.value === key)?.name ?? fallback

  return (
    <Box sx={{display: 'grid', gridTemplateColumns: {xs: '1fr', sm: 'repeat(3, 1fr)'}, gap: 2}}>
      {isFieldVisible('modeOfAssumption') && (
        <SelectNew
          label={fieldLabel('modeOfAssumption', 'Via di assunzione')}
          value={value.modeOfAssumption ?? ''}
          onChange={(modeOfAssumption) => set({modeOfAssumption: modeOfAssumption || undefined})}
          options={MODE_OF_ASSUMPTION_OPTIONS}
          placeholder="Seleziona una opzione"
        />
      )}
      {isFieldVisible('deviceOfAssumption') && (
        <SelectNew
          label={fieldLabel('deviceOfAssumption', 'Dispositivo')}
          value={value.deviceOfAssumption ?? ''}
          onChange={(deviceOfAssumption) => set({deviceOfAssumption: deviceOfAssumption || undefined})}
          options={DEVICE_OF_ASSUMPTION_OPTIONS}
          placeholder="Seleziona una opzione"
        />
      )}
      {isFieldVisible('speedOfDevice') && (
        <UnitValueField
          label={fieldLabel('speedOfDevice', 'Velocità device')}
          value={value.speedOfDevice}
          onChange={(speedOfDevice) => set({speedOfDevice})}
          unitOptions={SPEED_UNIT_OPTIONS}
        />
      )}
    </Box>
  )
}
